<template>
  <div
    class="protocol-list-setting-container"
    :style="{ marginBottom: (data.marginBottom ) / 16 + 'rem' }"
  >
    <ul class="list-container">
      <li
        v-for="(item, index) in data.lists"
        :key="index"
        class="list-item"
        @click="click(item)"
      >
        <p class="title">{{ item.title }}</p>
        <img
          class="icon"
          src="https://www.haohuan.com/datahub/file/2021-07/6b58662a6319698797a741e351366e41.png"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ProtocolListSetting", // 协议列表
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    click(item) {
      window.location.href = item.link;
    },
  },
};
</script>

<style lang="less" scoped>
.protocol-list-setting-container {
  width: 100%;
  .list-container {
    background: #fff;
    .list-item {
      width: calc(100% - 40px);
      margin: 0 auto;
      padding: 16px 0;
      border-bottom: 1px solid #ededf0;
      line-height: 22px;
      display: flex;
      align-items: center;
      .title {
        font-size: 15px;
        color: #2e2e33;
        width: calc(100% - 12px);
        word-break: break-all;
      }
      .icon {
        width: 12px;
        height: 12px;
      }
    }
    .list-item:last-child {
      border-bottom: none;
    }
  }
}
</style>
